export default __webpack_public_path__ + "assets/341a2508a7c5c6eff3106bbc2276dced.ttf";